"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feedback = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const tokens_1 = require("../../styles/tokens");
const Feedback_styles_1 = require("./Feedback.styles");
const getIconForFeedbackColour = (variant, iconName) => {
    switch (variant) {
        case "success":
            return (react_1.default.createElement(__1.Icon, { colour: "green", theme: "Fill", name: iconName !== null && iconName !== void 0 ? iconName : "Success", size: 3, title: "Success" }));
        case "information":
            return (react_1.default.createElement(__1.Icon, { colour: "blue", theme: "Line", name: iconName !== null && iconName !== void 0 ? iconName : "Info", size: 3, title: "Information" }));
        case "warning":
            return (react_1.default.createElement(__1.Icon, { colour: "orange", theme: "Fill", name: iconName !== null && iconName !== void 0 ? iconName : "Warning", size: 3, title: "Warning" }));
        case "error":
            return (react_1.default.createElement(__1.Icon, { colour: "red", theme: "Fill", name: iconName !== null && iconName !== void 0 ? iconName : "Error", size: 3, title: "Error" }));
        case "learning":
            return (react_1.default.createElement(__1.Icon, { colour: "purple", theme: "Line", name: iconName !== null && iconName !== void 0 ? iconName : "Info", size: 3, title: "Information" }));
        case "secondary":
            return (react_1.default.createElement(__1.Icon, { colour: "zinc", theme: "Line", name: iconName !== null && iconName !== void 0 ? iconName : "Info", size: 3, title: "Information" }));
        default:
            return (react_1.default.createElement(__1.Icon, { colour: "blue", theme: "Line", name: iconName !== null && iconName !== void 0 ? iconName : "Info", size: 3, title: "Information" }));
    }
};
const Feedback = ({ className, colour = "secondary", title, titleAs, content, children, props, iconName, }) => {
    if (!title && !content && !children) {
        console.error("At a minimum, you must add at least one of title, content or children props");
        return null;
    }
    return (react_1.default.createElement(Feedback_styles_1.StyledFeedback, Object.assign({ className: className, colour: colour }, props),
        iconName !== "None" && (react_1.default.createElement("div", null, getIconForFeedbackColour(colour, iconName))),
        react_1.default.createElement("div", { style: {
                paddingLeft: tokens_1.SIZES["1"],
            } },
            !!title && (react_1.default.createElement(__1.Text, { variant: "label", skinny: true, as: titleAs }, title)),
            !!content && !children && typeof content === "string" ? (react_1.default.createElement(__1.Text, { skinny: true }, content)) : (react_1.default.createElement("div", null, content)),
            children)));
};
exports.Feedback = Feedback;
//# sourceMappingURL=Feedback.js.map